<template>
  <ubi-page-container>
    <template v-slot:page-actions>
      <router-link :to="{ name: 'social-posts' }">
        <el-button type="primary">{{$t('prompt.goBackPostManagement')}}</el-button>
      </router-link>
    </template>
    <ubi-panel>
      <h3 class="mb-1">{{$t('prompt.textHeader1')}}</h3>
      <p>{{$t('prompt.textHeader2')}}</p>
    </ubi-panel>
    <el-row :gutter="20">
      <el-col :span="12" >
        <transition name="fade">
          <FormPrompt/>
        </transition>
      </el-col>
<!--      Libraries -->
      <el-col :span="12">
        <LibraryPrompt/>
      </el-col>
    </el-row>
  </ubi-page-container>
</template>

<script>
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'
import FormPrompt from '@/pages/prompt/components/FormPrompt.vue'
import LibraryPrompt from '@/pages/prompt/components/LibrairyPrompt.vue'
import {mapGetters} from "vuex";

export default {
  name: 'PromptLibraries',
  components: { LibraryPrompt, FormPrompt, UbiPanel, UbiPageContainer },
  data () {
    return {
      prompt: {
        annonceurId: 0,
        defaut: 0,
        diffuseurId: -1,
        donnees: [],
        id: null,
        prompt: '',
        reseau: null,
        temperature: 0.1,
        titre: '',
        ton: ''
      },
      reference: false,
      mainData: [],
      checkedData: [],
      dataSelectedList: ''
    }
  },
  computed: {
    ...mapGetters(['getSitimmoUser']),
    getLoadingStatus () {
      return this.$store.getters['promptLibraries/getIsLoading']
    }
  },
  methods: {
    reinitializedForm () {
      this.reference = false
      this.checkedData = []
      this.$store.commit('promptLibraries/resetPrompt')
      this.formSubmitted = false
    }
  },
  beforeMount () {
    this.$store.dispatch('promptLibraries/loadPrompts')
    this.$store.dispatch('promptLibraries/loadTonsIa')
    this.$store.dispatch('promptLibraries/loadListDataInitialByJob')
    this.$store.commit('promptLibraries/setAnnonceurId', this.getSitimmoUser.id)
    this.$store.commit('promptLibraries/setInfos', { annonceurId: this.getSitimmoUser.id, diffuseurId: null })
  },
  destroyed () {
    this.reinitializedForm()
    this.$store.dispatch('promptLibraries/loadPrompts')
  }
}
</script>

<style scoped>
.block {
  min-height: 1100px;
}
/* Animations */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0.5;
}
/*
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}*/
</style>
